// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"a77939ae","769":"dd2c49f0"}[chunkId] + ".chunk.js";
};